import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MasterService } from '../../../Services/master.service';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { TransactionService } from 'src/app/Services/transaction.service';
import { SpraStatusReport } from 'src/app/Models/ops';
import { SpraCompetitionCsaRateComponent } from '../../masters/spra-competition-csa-rate/spra-competition-csa-rate.component';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from 'src/app/Pipes/date-format.pipes';
import { MatTableDataSource } from '@angular/material/table';
import { ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SpraViewOpsComponent } from '../spra-view-ops/spra-view-ops.component';
import { NotificationService } from 'src/app/Services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Shared } from 'src/app/Models/master';


@Component({
  selector: 'app-spra-status-report',
  templateUrl: './spra-status-report.component.html',
  styleUrls: ['./spra-status-report.component.css'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
   ],
})
export class SpraStatusReportComponent implements OnInit {
  selectedItemsList : any = [];
  checkedIDs :string='';
  Saletypes:string='';
  ProdSegments:string='';
  ProdGroups:string='';
  checkboxesDataList = [
    {
      id: 'P',
      label: 'Pending',
      isChecked: true
    },
    {
      id: 'A',
      label: 'Approved',
      isChecked: false
    },
    {
      id: 'R',
      label: 'Rejected',
      isChecked: false
    },
    {
      id: 'V',
      label: 'Reviewed',
      isChecked: false
    }
  ]
  private utility: Utility
  public OfficeList: any[] = [];
  public EmployeeList: any[] = [];
  public ViewList :any []=[];
  public officeId:string;
  public Pending:string="P";
  public Approved:string="A";
  public Reject:string="R";
  public todays:Date;
   public fromdays:Date ;
  public FromDate:any;
  public ToDate:any;
  public EnteredBy:number;
  public customerName:string;
  public rptType:string="V";
  Enable:boolean = false;
  Profit:boolean = false;
  public ProductCategoryList: any[] = [];
  public ProductGroupList: any[] = [];
  SaleTypeList= [{SaleType:"DD"},{SaleType:"DL"},{SaleType:"LL"}];
  selectedSaleType=[]; 
  selectedProdSegment=[]; 
  selectedProdGroup=[]; 
  public SPRAStatusViewHeader: String[] = ["RequestNo","RequestDate","Office", "EnteredBy", "Salecode", "CustomerName","SaleType","SPRA","ProductSegmentDesc","Status","PendingWith","LastValidateDate"];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor(private _MasterService: MasterService
    , private cookieService: CookieService
    , private intl: MatPaginatorIntl
    , private changeDectector: ChangeDetectorRef
    ,private dialog: MatDialog
    ,private _NotificationService: NotificationService
    , private route: ActivatedRoute
    , private router: Router

    ,private _TransactionService: TransactionService) 
    { 
    this.utility = new Utility(this.cookieService);
    this.sort = new MatSort();
    this.paginator = new MatPaginator(this.intl, this.changeDectector);
    this.officeId=this.utility.user.officeId.toString();
    this.EnteredBy=0;
    this.customerName="";
    this.todays = new Date();
    this.fromdays= new Date(this.todays);
    this.fromdays.setDate(this.fromdays.getDate()-45)
    this.FromDate={"year": this.fromdays.getFullYear(),"month": this.fromdays.getMonth()+1,"day": this.fromdays.getDate()};
    this.ToDate={"year": this.todays.getFullYear(),"month": this.todays.getMonth()+1,"day": this.todays.getDate()};
    //this.rptType="E";
  }

  ngOnInit(): void {
    this.route.params.subscribe( (params) =>{
      if(params.IsProfit != undefined && params.IsProfit ==1){
        this.Profit = true;
      }
    });

    this._MasterService.GetAllOffices(this.utility.user.officeId == 1 ? 0 : this.utility.user.officeId).subscribe((d) => {
      
      if (this.utility.user.officeId == 1) {
        this.officeId="-1";
        this.OfficeList.push({ "officeId": "-1", "officeDesc": "-- All Office --" });
      }
      this.OfficeList = this.OfficeList.concat(d);
    this.changeOffice();
    },(error) => {                              //Error callback
      this.utility.Error(error);
    });

    
    

    //this.FromDate = this.utility.GetCurrentDate();
    //this.ToDate = this.utility.GetCurrentDate();
    if(this.rptType == "E"){
       this.dataSource.data.length=0;
    }

    this.BindProdSegment();
    this.BindProductGroup();
  }
 

BindProdSegment(){
  this._MasterService.GetAllProductCategory().subscribe((d) => {
      
    // this.ProductCategoryList.push({ "prodSegmentId": "-1", "prodSegmentDesc": "--All--" });
     this.ProductCategoryList = this.ProductCategoryList.concat(d);
 
 });
}

BindProductGroup(){
  this._MasterService.GetAllProductGroup().subscribe((d) => {
    //this.ProductGroupList.push({ "productGroupId": "-1", "productGroupDesc": "--All--" });
    this.ProductGroupList = this.ProductGroupList.concat(d);

});
}

GetSelectedSaleType(){
  this.Saletypes="";
  if(this.selectedSaleType.length>0){
    this.selectedSaleType.forEach((value,index)=>{
      this.Saletypes+= value +","
   });
    this.Saletypes = this.Saletypes.substring(0,this.Saletypes.length-1);
  }
 
}

GetSelectedProdSegment(){
  this.ProdSegments="";
  if(this.selectedProdSegment.length>0){
    this.selectedProdSegment.forEach((value,index)=>{
      this.ProdSegments+=value+",";
      });
      this.ProdSegments = this.ProdSegments.substring(0,this.ProdSegments.length-1);
  }
 
}

GetSelectedProdGroup(){
  this.ProdGroups="";
  if(this.selectedProdGroup.length>0){
    this.selectedProdGroup.forEach((value,index)=>{
      this.ProdGroups+=value+",";
      });
      this.ProdGroups = this.ProdGroups.substring(0,this.ProdGroups.length-1);
  }
 
}
 BindEmployee(){
    this.EmployeeList = [];
    let Cond:string;
    Cond=" EM.OfficeID = " + this.officeId;   
    this._MasterService.GetEmployeeListOnBasisOfOffice(Cond,this.utility.user.employeeId).subscribe((d:any) => {
      if(d){
      let EmployeeDetail:any;
      if (this.utility.user.officeId == 1) {
        this.EmployeeList.push({ "employeeid": -1, "employeename": "-- All Employee --" });
      }
      EmployeeDetail = JSON.parse(d);
       this.EmployeeList = this.EmployeeList.concat(EmployeeDetail);
        this.EnteredBy=-1;
      // this.changeOffice(this.utility.user.officeId);
    }
    },(error) => {                              //Error callback
      this.utility.Error(error);
    });
  }

  changeOffice() {
    // let office: any = this.OfficeList.filter(o =>
    //   o.officeId == officeid
    // )[0];
    // this.officeId = parseInt(office.officeId);
    // alert(this.officeId);
    this.BindEmployee();
  }

  changeSelection() {
    this.fetchSelectedItems()
  }

  fetchSelectedItems() {
    this.selectedItemsList = this.checkboxesDataList.filter((value, index) => {
      return value.isChecked
    });
  }

  fetchCheckedIDs() {
    this.checkedIDs = '';
    this.checkboxesDataList.forEach((value, index) => {
      if (value.isChecked) {
         this.checkedIDs += value.id +',';
      }
    });
    if(this.checkedIDs.length>0){
      this.checkedIDs = this.checkedIDs.substring(0,this.checkedIDs.length-1);
    }

  }


 validation():boolean{
   let Valid:boolean=true;
  if(this.FromDate == undefined){
    this._NotificationService.showWarning("Please enter From Date ", "");
    Valid=false;
  }
  else if(this.ToDate == undefined){
    this._NotificationService.showWarning("Please enter To Date", "");
    Valid= false;
  }
  else if(this.checkedIDs.length==0){
    this._NotificationService.showWarning("Please select status", "");
    this.dataSource.data.length=0;
    Valid= false;
  }
   return Valid;
 }

  OnSubmit(){
   
    this.Saletypes="";
    this.ProdSegments="";
    this.ProdGroups="";
    this.dataSource.data.length=0;
    this.fetchCheckedIDs();
     if(this.validation()){
      this.GetSelectedSaleType()
      this.GetSelectedProdSegment()
      this.GetSelectedProdGroup()
      this.GenerateExcel();   
     }
  }

  GenerateExcel()
  {
    let spraStatusReport:SpraStatusReport;
    spraStatusReport=new SpraStatusReport();
    spraStatusReport.Status = this.checkedIDs;
    spraStatusReport.FromDate=this.utility.GetdatePickerDate(this.FromDate);
    spraStatusReport.ToDate=this.utility.GetdatePickerDate(this.ToDate);
    spraStatusReport.CustomerName=this.customerName;
    spraStatusReport.SaleType = this.Saletypes;
    spraStatusReport.ProdSegment = this.ProdSegments;
    spraStatusReport.ProdGroup = this.ProdGroups
    if(parseInt(this.officeId) ==-1)
    {
      spraStatusReport.officeid=0;
    }
    else{
      spraStatusReport.officeid=parseInt(this.officeId);  
    }
   
    if(this.EnteredBy==-1)
    {
      spraStatusReport.EmployeeID=0;
    }
    else{
      spraStatusReport.EmployeeID = this.EnteredBy;
    }
    spraStatusReport.LogInEmployeeIdd=this.utility.user.employeeId;
//  debugger   
if(this.rptType == "E"){
     this.Enable=true;
    this._TransactionService.GetSPRAStatusReportData(spraStatusReport).subscribe((d:any)=>{      
      if(d){         
        this.utility.downloadExcel(d);
        this.dataSource.data.length=0;
      }else{
        this._NotificationService.showSuccess("No SPRA request found for the search criteria","Result");
      }
      this.Enable=false;
    });
     }
     else{
      this._TransactionService.GetSPRAStatusReportView(spraStatusReport).subscribe((d:any)=>{
        let data:[] = d;
        if(data.length>0){         
          this.dataSource = new MatTableDataSource(d);
         setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
         
        }else{
          this._NotificationService.showSuccess("No SPRA request found for the search criteria","Result");
        }
  
      });
     }
     
    
  }
  public doFilter = (event: any) => {
    this.dataSource.filter = event.target.value.trim().toLocaleLowerCase();
  }

  onRequestClick(row:any){
    let _Profit:boolean = this.Profit;
    if(row.priceRefCalculatiion == false){
      _Profit = false;
    }
    let data =  {IsForPriceRef:false,SPRAId: row.id,RefId:row.refId,salecode:row.salecode,officeId:row.officeId,CompanyID:row.companyId,ProfitTag:_Profit };
    
   // this.router.navigateByUrl("spra-view-ops",{ state:{data:data}});
    this.router.navigate([], {
      state: data
    }).then(result => {  
      window.open("spra-view-ops/"+btoa(JSON.stringify(data)) +"", '');     
    });



    // const dialogRef = this.dialog.open(SpraViewOpsComponent, {
    //   width: '110vw',
    //   maxWidth:'120vw',
    //   height:'90%',
    //   data: data      
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
       
    //   }
    // });
  
  }

 
}
